import type { SharedParameterDataType } from '../../types/sharedParameter.types';

export function parseSharedParameterDataType(
  value: string | undefined
): SharedParameterDataType | undefined {
  switch (value?.trim().toUpperCase()) {
    case 'TEXT': return 'TEXT';
    case 'INTEGER': return 'INTEGER';
    case 'NUMBER': return 'NUMBER';
    case 'LENGTH': return 'LENGTH';
    case 'AREA': return 'AREA';
    case 'VOLUME': return 'VOLUME';
    case 'ANGLE': return 'ANGLE';
    case 'SLOPE': return 'SLOPE';
    case 'CURRENCY': return 'CURRENCY';
    case 'MASSDENSITY': return 'MASSDENSITY';
    case 'URL': return 'URL';
    case 'MATERIAL': return 'MATERIAL';
    case 'IMAGE': return 'IMAGE';
    case 'YESNO': return 'YESNO';
    case 'MULTILINETEXT': return 'MULTILINETEXT';
    case 'FAMILYTYPE': return 'FAMILYTYPE';
    case 'PIPE_MASS': return 'PIPE_MASS';
    default: return undefined;
  }
}
